import type { Defaults } from 'chart.js';

export type DeepPartial<T> = T extends object
    ? {
          [P in keyof T]?: DeepPartial<T[P]>;
      }
    : T;

const scale: DeepPartial<Defaults['scale']> = {
    offset: true,
    border: {
        display: false,
    },
    grid: {
        display: false,
    },
};

const elements: DeepPartial<Defaults['elements']> = {
    line: {
        tension: 0.3,
        borderCapStyle: 'round',
    },
    bar: {
        borderRadius: 5,
    },
};

const font: DeepPartial<Defaults['font']> = {
    weight: 'bold',
    size: 10,
};

export const defaultChartJsConfiguration: DeepPartial<Defaults> = {
    clip: false,
    responsive: true,
    maintainAspectRatio: false,
    scale,
    elements,
    font,
    color: '#0A2540',
};

export const SMALL_TOOLTIP_TAB = '  ';
export const LARGE_TOOLTIP_TAB = '     ';
